import React from 'react'
import { colors } from 'src/constants'
import { TSvgIcon } from 'src/types/common.types'

export default function VentureNewIcon({ color = colors.primary[600], ...rest }: TSvgIcon) {
    return (
        <svg {...rest} width="35" height="16" fill={color} viewBox="0 0 35 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.7435 14.1477L8.38583 14.5635L4.45163 9.10165L4.44266 15.2587L2.08503 15.6745L2.08804 5.69431L4.44567 5.2786L8.38474 10.768L8.38884 4.58331L10.7465 4.1676L10.7435 14.1477ZM14.3968 5.44311L14.407 7.51683L17.5643 6.96012L17.5608 8.79459L14.4035 9.35131L14.3992 11.584L17.9701 10.9543L17.9674 12.874L12.0388 13.9193L12.0418 3.93919L17.9704 2.89383L17.9677 4.81346L14.3968 5.44311ZM32.4059 0.348455L29.8798 10.7735L27.0258 11.2767L25.4777 4.99613L23.8823 11.831L21.0284 12.3342L18.5772 2.78682L21.1003 2.34194L22.4942 9.36051L24.2162 1.79251L26.822 1.33304L28.4706 8.26406L29.869 0.795773L32.4059 0.348455Z" />
        </svg>
    )
}
